import store from '@/store'
import { hasPermission } from '@/router/middleware/permissionGuard'
import { hasAdminRole } from '@/router/middleware/adminGuard'
import { getLocalLocale, redirectToDashboard, setLocalLocale } from '@/router/helpers'
import { defaultLocale } from '@/router/router'

export function middleware(to, from, next) {
  let { locale } = to.params
  
  // Handle authentication
  if (to.meta.requiresAuth) {
    if (store.getters.isAuthenticated) {
      return next()
    } else {
      return next({
        name: 'homepage',
        params: { locale: locale }
      })
    }
  }
  
  // Handle locale
  if (!store.getters.locale) {
    // set to default
    if (!locale) setLocalLocale(defaultLocale)
    // set to what given from params
    else setLocalLocale(locale)
  }
  if (!locale) {
    let localLocale = getLocalLocale()
    const redirectTo = `/${localLocale}${to.fullPath}`
    next({ path: redirectTo })
  }
  
  // @TODO: Check if this is still needed
  // if (to.name === 'faq') {
  //   to.meta.requiresAuth = store.getters.isAuthenticated
  // }
  
  // Handle admin role
  if (hasAdminRole(to)) {
    return next()
  }
  
  // Handle permissions
  if (!hasPermission(to)) {
    return next({
      name: 'homepage',
      params: { locale: locale }
    })
  }
  
  // @TODO: Check if this is still needed
  // if (isRedirectRequired(to)) {
  //   return next({
  //     name: 'homepage',
  //     params: { locale: locale }
  //   })
  // } else if (redirectToDashboard(to)) {
  
  // Handle redirects
  if (redirectToDashboard(to)) {
    if (store.getters.hasPermission('Input')) {
      return next({
        name: 'inbox',
        params: { locale: locale }
      })
    } else {
      return next({
        name: 'dashboard',
        params: { locale: locale }
      })
    }
  } else {
    return next()
  }
}
